import React from 'react'
import { useMediaQuery } from 'react-responsive'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { isTabletOrMobileQuery } from '../../utils'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'

const Footer = () => {
  const { baseUrl } = useSelector((state: RootState) => state.misc)

  return (
    <footer className='margin-bottom text-dark text-center text-small pt-3'>
      <hr
        style={{
          width: `${useMediaQuery(isTabletOrMobileQuery) ? '100%' : '50%'}`,
        }}
      />
      Made with{' '}
      <FontAwesomeIcon
        icon='heart'
        className='text-danger'
        role='presentation'
      />{' '}
      -{' '}
      <a className='dark-primary-text' href='https://mecodia.de'>
        mecodia GmbH
      </a>
      {useMediaQuery(isTabletOrMobileQuery) ? (
        <>
          <br />
        </>
      ) : (
        <> - </>
      )}
      <a className='dark-primary-text' href={`${baseUrl}/impressum`}>
        Impressum
      </a>{' '}
      -{' '}
      <a className='dark-primary-text' href={`${baseUrl}/datenschutz`}>
        Datenschutz
      </a>{' '}
      -{' '}
      <a
        className='dark-primary-text'
        href={`${baseUrl}/barrierefreiheit`}
        target='_blank'
      >
        Barrierefreiheit
      </a>
      { process.env.REACT_APP_GIT_BUILD_VERSION && <>
      {' '}-{' '}<span>{process.env.REACT_APP_GIT_BUILD_VERSION}</span>
      </> }
    </footer>
  )
}

export default Footer
